import { render } from "./GroupItinerary.vue?vue&type=template&id=fd33d132"
import script from "./GroupItinerary.vue?vue&type=script&lang=js"
export * from "./GroupItinerary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__